export enum SystemMessageType {
  START_SCREEN_SHARING = 'START_SCREEN_SHARING',
  SCREEN_SHARING_STARTED = 'SCREEN_SHARING_STARTED',
  EXTERNAL_CANCEL_SCREEN_SHARING = 'EXTERNAL_CANCEL_SCREEN_SHARING',
  EXTERNAL_END_SCREEN_SHARING = 'EXTERNAL_END_SCREEN_SHARING',
  NO_CAPABILITY_FOR_SCREEN_SHARING = 'NO_CAPABILITY_FOR_SCREEN_SHARING',
  TYPING = 'TYPING',
  TYPING_END = 'TYPING_END',
  WAITING = 'WAITING',
  END_WAITING = 'END_WAITING',
  VISITOR_STATS = 'VISITOR_STATS',
  ERROR = 'ERROR',
  CONSENT = 'CONSENT',
  DISCONNECT = 'DISCONNECT',
  UPDATE_USER_INFO = 'UPDATE_USER_INFO',
  WEBSOCKET_DISCONNECT_ORDER = 'WEBSOCKET_DISCONNECT_ORDER',
}
